import React from "react";
import { isLightColor, hasLongWord } from "../../utils/utils";

import "./Card.scss";

const Card = ({ thing, selected, onSelect, cardAnimation, style }) => {
  const handleClick = () => {
    onSelect(thing);
  };

  const backgroundColor = style && style.backgroundColor;
  const explicitTextColor = style && style.color;
  const hasLightBackground = isLightColor(backgroundColor);

  const computedStyle = {
    ...style,
    "--card-bg-color": backgroundColor || "#ffffff",
    color:
      hasLightBackground && !explicitTextColor ? "#111" : style && style.color,
  };

  const isCompact =
    typeof thing === "string" && thing.trim().length >= 20
      ? true
      : false || hasLongWord(thing);

  return (
    <div
      className={`Card ${selected ? "selected" : ""} ${
        selected && cardAnimation ? cardAnimation : ""
      } ${isCompact ? "compact" : ""} ${hasLightBackground ? "light-bg" : ""}`}
      onClick={handleClick}
      style={computedStyle}
    >
      {thing}
    </div>
  );
};

export default Card;
